module.exports = __webpack_public_path__ + "assets/img/year-light3.e06d84c5.png";